import React, { useState, useEffect, useMemo } from "react";
import { Button, Card, CardContent, CardHeader, Grid } from "@material-ui/core";

import Layout from "../../components/Layout";
import locationStore from "../../stores/locationStore";
import { useObserver } from "mobx-react-lite";
import { toJS } from "mobx";

import { OutTable, ExcelRenderer } from "react-excel-renderer";
import { CSVLink, CSVDownload } from "react-csv";
import { copyCheck, startJob } from "../../services/copy";
// import { proxy } from "../../../package.json";
import SaveIcon from "@material-ui/icons/Save";
const isDev = process.env.NODE_ENV !== "production";

export default function Copy2(props) {
  const [form, setForm] = useState({
    loc: "DSU",
    titleIndex: 5,
    headerCol: [],
    cols: [],
    rows: []
  });
  const _setLoc = loc => {
    setForm({ ...form, loc: loc });
  };
  const _setData = (cols, rows) => {
    if (Array.isArray(rows)) {
      let titleIndex = 0;
      const sRows = rows.map((item, index) => {
        if (index === 0) {
          item.splice(1, 0, "단행본", "전자책", "비고");
          titleIndex = item.indexOf("도서명");
          if (titleIndex < 0) {
            titleIndex = item.indexOf("서명");
          }
        } else {
          item.splice(1, 0, "checking", "checking", "");
        }
        return item;
      });
      const cols2 = sRows[0];
      const rows2 = sRows.slice(1, sRows.length);
      setForm({
        ...form,
        titleIndex: titleIndex,
        cols: cols2,
        rows: rows2,
        headerCol: cols
      });
    }
  };

  const _setRow = rows => {
    setForm({ ...form, rows: rows });
  };

  return (
    <Layout>
      <Grid container spacing={3}>
        <Grid item xs>
          <Form
            {...form}
            setLoc={_setLoc}
            setData={_setData}
            setRow={_setRow}
          />
        </Grid>
        <Grid item xs>
          <Status {...form} />
        </Grid>
      </Grid>
    </Layout>
  );
}

const Form = props => {
  const { loc, titleIndex, rows, setLoc, setData, setRow } = props;
  const [locationList, setLocationList] = useState([]);
  const [marcType, setMarcType] = useState("A,B");
  const [emarcType, setEmarcType] = useState("G");
  const [otwa1, setOtwa1] = useState("IDX");
  const searchIndex = [
    { name: "통합", value: "IDX" },
    { name: "서명", value: "T" }
  ];

  const getLocationList = async () => {
    const data = await locationStore.getLocationList();
    setLocationList(data);
  };

  const start = async () => {
    const marc = marcType.split(",");
    const emarc = emarcType.split(",");

    // for (const row of rows) {
    //   const title = row[titleIndex];
    //   const chk = await startJob(loc, title, marc, emarc, otwa1);
    //   const { book, ebook, bigo } = chk;
    //   row[1] = book;
    //   row[2] = ebook;
    //   row[3] = bigo;
    //   setRow(rows);
    // }

    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];
      const title = row[titleIndex];
      const chk = await startJob(loc, title, marc, emarc, otwa1);
      const { book, ebook, bigo } = chk;
      row[1] = book;
      row[2] = ebook;
      row[3] = bigo;
      setRow(rows);
    }
  };

  useEffect(() => {
    getLocationList();
  }, []);
  return useObserver(() => (
    <Card>
      <CardHeader></CardHeader>
      <CardContent>
        {/* <h2>{proxy}</h2> */}
        <h4>{loc}</h4>
        <h4>검색 {otwa1}</h4>

        <br></br>
        <input
          type="file"
          onChange={e => {
            let fileObj = e.target.files[0];

            ExcelRenderer(fileObj, (err, resp) => {
              if (err) {
                this.alert.show(err);
              } else {
                const { cols, rows } = resp;
                setData(cols, rows);
              }
            });
          }}
          style={{ padding: "10px" }}
        />
        <input
          value={marcType}
          onChange={e => {
            setMarcType(e.target.value.toUpperCase());
          }}
        />
        <input
          value={emarcType}
          onChange={e => {
            setEmarcType(e.target.value.toUpperCase());
          }}
        />
        <select
          onChange={e => {
            setOtwa1(e.target.value);
          }}
        >
          {searchIndex.map((item, index) => (
            <option key={index.toString()} value={item.value}>
              {item.name}
            </option>
          ))}
        </select>
        <Button
          onClick={() => {
            start();
          }}
        >
          시작하기
        </Button>
        {locationList.map((item, index) => (
          <Button
            key={index.toString()}
            id={item.loc}
            itemID={item.loc}
            variant="contained"
            color="primary"
            onClick={() => {
              setLoc(item.loc);
            }}
            style={{ margin: 5 }}
          >
            {item.locname}
          </Button>
        ))}
      </CardContent>
    </Card>
  ));
};

const LocList = props => {
  return <h2>locList</h2>;
};

const Status = props => {
  const { cols, rows, headerCol } = props;
  const mRows = useMemo(() => {
    if (Array.isArray(rows) && rows.length > 0) {
      const temp = rows.slice();
      temp.unshift(cols);
      return temp;
    }
    return [];
  }, [cols, rows]);
  return (
    <Card>
      <CardContent>{JSON.stringify(cols)}</CardContent>
      <div style={{ height: 600, overflow: "scroll" }}>
        <OutTable
          data={rows}
          columns={headerCol}
          tableClassName="ExcelTable2007"
          tableHeaderRowClass="heading"
        />
      </div>

      <CSVLink
        data={mRows}
        filename={"copyCheck.csv"}
        className="btn btn-primary"
      >
        <Button
          variant="contained"
          color="primary"
          size="large"
          startIcon={<SaveIcon />}
        >
          Save CSV
        </Button>
      </CSVLink>
    </Card>
  );
};
